import { jitsiLocalStorage } from '@jitsi/js-utils';
import i18next from 'i18next';
import { sha256 } from 'js-sha256';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { apiKEY } from '../../base/config/constants';
import { removeUrlState, setJWT, setJwtStorage, setRenderContent } from '../../base/jwt';
import { JWT_STORAGE, SET_ACCESS_TOKEN } from '../../base/jwt/actionTypes';
import { fetchAxiosApi, fetchpreRegApi, setJWTforGuest, setMeetingDetailsinJWT, setuserDetails } from '../../base/mtApi';
import { updateSettings } from '../../base/settings';
import { getBackendSafeRoomName, parseURLParams } from '../../base/util';
import { checkIfNotReactNative, isDomainWeborNative } from '../../base/util/checkOS';
import Conference from '../../conference/components/web/Conference';
import PreLoader from '../../conference/components/web/PreLoader';


declare var config: object;

// declare var interfaceConfig: object;
/**
 * Component to handle API calls before joining the conference
 * @returns {JSX.Element}
 */
export default function ApiCalls() {
    const dispatch = useDispatch();
    const [ openLoader, setOpenLoader ] = useState(true);
    const [ hideConference, setHideConference ] = useState(true);
    const state1 = useSelector(state => state['features/base/jwt']);
    const { interfaceConfig } = useSelector(state => state['features/base/config']);
    const { userDetails, pregData } = useSelector(state => state['features/base/mtApi']);

    const iAmRecorder = useSelector(state => state['features/base/config'].iAmRecorder);

    // Only in iframe and with jwt or jwtData applied supplied, we are removing the accessToken from localStorage for integration customers
    if (checkIfNotReactNative()) {
        if ((state1?.jwt || state1?.jwtData) && window.self !== window.top) {
            jitsiLocalStorage.removeItem('accessToken');
        }
    }

    const userAccessToken = jitsiLocalStorage.getItem('accessToken');
    const roomName = getBackendSafeRoomName(useSelector(state => state['features/base/conference'].room));
    const { locationURL } = useSelector(state => state['features/base/connection']);

    React.useLayoutEffect(() => {
        dispatch(fetchpreRegApi());
    }, []);

    const _clearInvalidAccessToken = () => {
        jitsiLocalStorage.removeItem('accessToken');
        dispatch({
            type: SET_ACCESS_TOKEN,
            accessToken: null
        });
        dispatch(updateSettings({
            accessToken: null
        }));
        dispatch(setuserDetails(undefined));
        dispatch(setRenderContent(true));
        dispatch(setJWT(null));
        dispatch(setJwtStorage(null));
        setOpenLoader(false);
        setHideConference(false);
    };

    useEffect(() => {

        let accesTokn = state1.accessToken ?? userAccessToken === 'null' ? null : userAccessToken;
        const urlTest = locationURL?.pathname?.length;
        const urrr = parseURLParams(locationURL, true, 'search');

        if (urrr?.logout && urrr?.client_id && urrr?.client_id === config?.MH_CLIENT_ID) {
            dispatch(setuserDetails(undefined));
            accesTokn = undefined;
            jitsiLocalStorage.clear();

            setTimeout(() => {
                setOpenLoader(false);
            }, 2000);
        }

        if ((_.isNil(userDetails) && pregData && accesTokn) || Boolean(_.isNil(userDetails) && urlTest <= 1 && accesTokn)) {

            const moement = moment().seconds(0)
                .milliseconds(0)
                .format('X');

            const mesh256 = sha256(`${apiKEY}:MH:${moement}`);

            const preRegObject = JSON.stringify({
                'client_id': config.MH_CLIENT_ID,
                'credentials': mesh256,
                ...isDomainWeborNative,
                'meeting_id': roomName
            });

            fetchAxiosApi('customer/user_details', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state1.accessToken ?? userAccessToken}`
                },
                body: preRegObject
            }).then(response => {
                const responseStatus = response?.response?.status ?? response?.status ?? response?.code;

                if (responseStatus === 401) {
                    _clearInvalidAccessToken();

                    return;
                }

                const isTrueReg: boolean = Boolean(pregData?.is_pre_registration);

                // const isTrueGuest: boolean = Boolean(preRegData?.allow_guest === 1);
                const { jwt = '' } = response?.data ?? {};

                // Also Skipping the pre-registration page redirect for Recorder
                if (isTrueReg && !state1.jwt && !state1.jwtData && _.isEmpty(jwt) && !iAmRecorder === true) {
                    return window.location.replace(`${config?.brandedPreRegistrationURL ? config?.brandedPreRegistrationURL : pregData.registration_url}`);
                }

                // setUserd(response.data);
                if (response.success) {
                    const namess = response?.data?.name;
                    const emailss = response?.data?.email;
                    const pict = response?.data?.picture;

                    // This for the case when default language English is
                    // changed by integration customers and we do not want to overwrite with user_details api.
                    if (config?.defaultLanguage === 'en') {
                        const langPref = response?.data?.strip_details?.language_preference;
                        const normalizedLang = langPref === 'in' ? 'hi' : langPref;

                        i18next.changeLanguage(normalizedLang);
                    }

                    dispatch(updateSettings({
                        avatarURL: pict,
                        displayName: namess,
                        email: emailss
                    }));
                    dispatch({
                        type: SET_ACCESS_TOKEN,
                        accessToken: state1.accessToken ?? userAccessToken
                    });
                    const getJwt = response.data?.jwt;
                    const accessTokenForLogin = state1.accessToken ?? userAccessToken;

                    if (!_.isEmpty(getJwt) && !state1?.jwt) {
                        dispatch({
                            type: JWT_STORAGE,
                            jwtData: getJwt
                        });
                    } else {
                        setTimeout(() => {
                            setHideConference(false);
                        }, 2000);
                    }
                    if (_.isEmpty(getJwt) && !state1?.jwt && !state1.jwtData && interfaceConfig?.applyMeetingSettings === true) {
                        dispatch(setJWTforGuest());
                    } else if (
                        _.isEmpty(getJwt)
                    && accessTokenForLogin
                    && !state1?.jwt
                    && !state1.jwtData) {
                        dispatch(setMeetingDetailsinJWT()); // setMeetingDetailsinJWT
                    }
                } else {
                    jitsiLocalStorage.removeItem('accessToken');
                }

                setTimeout(() => {
                    setOpenLoader(false);
                }, 2000);
                dispatch(setuserDetails(response.data));
            })
                .catch(() => {
                    setTimeout(() => {
                        setOpenLoader(false);
                        dispatch(setRenderContent(true)); // To render the Content and hiding the Preloader in catch case
                        dispatch(setJWT(null));
                        dispatch(setJwtStorage(null));
                    }, 2000);
                });

        }

        const isTrueReg: boolean = Boolean(pregData?.is_pre_registration);

        // // const isTrueGuest: boolean = Boolean(preRegData?.allow_guest === 1);

        // Also Skipping the pre-registration page redirect for Recorder
        if (isTrueReg && !state1.jwt && !state1.jwtData && !accesTokn && parseURLParams(locationURL)?.mt === undefined && !iAmRecorder === true) {
            return window.location.replace(`${config?.brandedPreRegistrationURL ? config?.brandedPreRegistrationURL : pregData.registration_url}`);
        }

        if (!accesTokn) {
            setTimeout(() => {
                setOpenLoader(false);
                setHideConference(false);
            }, 2000);
        }

        if (userDetails) {
            setLoginButton(true);
        }


    }, [ pregData?.success ]);

    React.useEffect(() => {
        if (!openLoader && (state1.isRendered || state1?.jwt || state1.jwtData)) {
            setHideConference(false);
        }
    }, [ openLoader, state1?.isRendered, state1?.jwt ]);

    React.useEffect(() => {
        if (!hideConference) {
            setTimeout(() => {
                dispatch(removeUrlState());
            }, 500);
        }
    }, [ hideConference ]);


    return (
        <>
            {
                hideConference
                    ? <PreLoader interfaceConfig = { interfaceConfig } /> : <Conference />
            }
        </>
    );
}
